// extracted by mini-css-extract-plugin
module.exports = {"background":"Popup--background--2TMlK","background_logo":"Popup--background_logo--3_Xye","heading":"Popup--heading--2nbjP","paragraph":"Popup--paragraph--12kSn"};